import { css } from 'styled-components';

export default () => css`
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.baseFontSize};
  line-height: ${({ theme }) => theme.lineHeight};
  color: ${({ theme }) => theme.textColor};
  font-weight: normal;
  background-color: transparent;
`;
